import { ResultCode } from '@iotize/tap/client/api';

import { TapResponse } from './response-impl';
import { Tap } from './tap';

/**
 * If response status code is NOT_IMPLEMENTED or NOT_FOUND it will returns the default value
 * @param responsePromise
 * @param defaultValue
 */
export async function defaultValueIfTapRequetNotImplemented<T>(
  responsePromise: Promise<TapResponse<T>>,
  defaultValue: T,
) {
  const response = await responsePromise;
  if (!response.isSuccessful()) {
    if (
      response.status === ResultCode.NOT_IMPLEMENTED ||
      response.status === ResultCode.NOT_FOUND
    ) {
      return defaultValue;
    }
  }
  return response.body();
}

/**
 * Utility function add a new getter to the Tap prototype
 */
export function defineTapPropertyExtension<T>(
  propName: string,
  factory: (context: { tap: Tap }) => T,
) {
  Object.defineProperty(Tap.prototype, propName, {
    get(this: Tap) {
      const that: any = this;
      const hiddentPropName = `__${propName}__`;
      if (!that[hiddentPropName]) {
        that[hiddentPropName] = factory({
          tap: this,
        });
      }
      return that[hiddentPropName];
    },
    enumerable: false,
    configurable: true,
  });
}
